import { green, mint, lightGreenAlt, darkGreen, darkGreenAlt } from './colors';
import { createTheme } from '@sendbird/uikit-react-native-foundation';
import {
  LightUIKitTheme,
  Palette,
} from '@sendbird/uikit-react-native-foundation';

// Web theme configuration
export const sendbirdColorSet = {
  '--sendbird-light-primary-500': darkGreen,
  '--sendbird-light-primary-400': darkGreenAlt,
  '--sendbird-light-primary-300': green,
  '--sendbird-light-primary-200': lightGreenAlt,
  '--sendbird-light-primary-100': mint,
};

LightUIKitTheme.palette = {
  ...Palette,
  primary100: mint,
  primary200: lightGreenAlt,
  primary300: green,
  primary400: darkGreenAlt,
  primary500: darkGreen,
};

// React Native theme configuration
export const SendbirdLightTheme = createTheme({
  colorScheme: 'light',
  palette: {
    ...LightUIKitTheme.palette,
    primary100: mint,
    primary200: lightGreenAlt,
    primary300: green,
    primary400: darkGreenAlt,
    primary500: darkGreen,
  },
  colors: () => ({
    ...LightUIKitTheme.colors,
    ui: {
      ...LightUIKitTheme.colors.ui,
    },
  }),
});
